import React from "react";
import {
  WSElement,
  WSFlexBox,
  WSText,
  WSIcon
} from "@wingspanhq/fe-component-library";
import { IOAuthClient } from "../types";
import styles from "./ClientInfo.module.scss";

interface ClientInfoProps {
  client: IOAuthClient;
}

export const ClientInfo: React.FC<ClientInfoProps> = ({ client }) => {
  return (
    <WSFlexBox.Center direction="column" mb="L">
      {client.logoUri ? (
        <img
          src={client.logoUri}
          alt={`${client.clientName} logo`}
          className={styles.logo}
        />
      ) : (
        <WSElement className={styles.logoPlaceholder}>
          <WSIcon name="user" size="L" color="gray600" />
        </WSElement>
      )}

      <WSText.Heading3 mb="XS" className={styles.title}>
        {client.clientName}
      </WSText.Heading3>

      <WSText.Paragraph color="gray600" className={styles.description}>
        wants to access your Wingspan account
      </WSText.Paragraph>

      {client.clientUri && (
        <WSElement mt="XS">
          <a
            href={client.clientUri}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.clientLink}
          >
            Learn more about {client.clientName}
          </a>
        </WSElement>
      )}
    </WSFlexBox.Center>
  );
};
